/*
  Lily & June product photos on phones (operator 27-10-2026, as Kosso Nutrition, same as Sableau and Thighrise):
  the theme's own thumbnail strip replaces the dots (templates/product.json, slideshow_mobile_controls_style), and this
  adds a magnifier bottom right of the photo. A tap on it opens the photo full screen on white; a tap anywhere closes it.
*/
(function () {
  var slides = document.querySelector('media-gallery slideshow-slides');
  if (!slides || !window.matchMedia('(max-width: 749px)').matches) return;
  var host = slides.parentElement;
  host.classList.add('lj-zoomhost');
  var btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'lj-zoom'; btn.setAttribute('aria-label', window.LJ_I18N.zoom_in);
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" width="15" height="15" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8.5v5M8.5 11h5"/></svg>';
  host.appendChild(btn);
  btn.addEventListener('click', function () {
    var items = slides.children, slide = items[Math.min(items.length - 1, Math.round(slides.scrollLeft / (slides.clientWidth || 1)))];
    var img = slide && slide.querySelector('img');
    if (!img) return;   // a video slide has its own controls
    var lb = document.createElement('div');
    lb.className = 'lj-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', window.LJ_I18N.photo);
    lb.innerHTML = '<button type="button" class="lj-lb__x">&times;</button><img alt="">';
    lb.querySelector('button').setAttribute('aria-label', window.LJ_I18N.close);
    lb.querySelector('img').src = (img.currentSrc || img.src).replace(/width=\d+/, 'width=1800');
    lb.addEventListener('click', function () { lb.remove(); document.documentElement.classList.remove('lj-lb-open'); });
    document.body.appendChild(lb); document.documentElement.classList.add('lj-lb-open');
  });
})();
